/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Openthread1Inputs */

const zh_learn_openthread1 = /** @type {(inputs: Learn_Openthread1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打开对话`)
};

const en_learn_openthread1 = /** @type {(inputs: Learn_Openthread1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open thread`)
};

const es_learn_openthread1 = /** @type {(inputs: Learn_Openthread1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir conversación`)
};

/**
* | output |
* | --- |
* | "Open thread" |
*
* @param {Learn_Openthread1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_openthread1 = /** @type {((inputs?: Learn_Openthread1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Openthread1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_openthread1(inputs)
	if (locale === "en") return en_learn_openthread1(inputs)
	return es_learn_openthread1(inputs)
});
export { learn_openthread1 as "learn_openThread" }